import { ICustomPropertiesElement } from '../base/components/CustomProperties/components/CustomProperty/types';

export function getElementsClone (
    elements: ICustomPropertiesElement[],
    cleanChanges?: boolean,
    elementsState?: ICustomPropertiesElement[]
): ICustomPropertiesElement[] {
    return elements.map(element => {
        let changed: Partial<ICustomPropertiesElement> = {};
        const elementState = !!elementsState && elementsState.find(item => item.id === element.id);
        if (!cleanChanges && elementState) {
            if (elementState.isChanged) {
                changed = {
                    ...element,
                    isChanged: true,
                    value: elementState.value,
                };
            }
            changed.removed = elementState.removed;
        }

        return {
            ...element,
            options: element.options ? element.options.map(option => ({...option})) : [],
            ...changed
        };
    });
};
